// extracted by mini-css-extract-plugin
export default {"game_body":"Game_game_body__vl+8+","map_image":"Game_map_image__fSmfJ","map_container":"Game_map_container__cxTp6","game_body_street":"Game_game_body_street__wHtcl"};